/**
 * Schema.org BreadcrumbList JSON-LD block. One per page — nested or
 * repeated blocks fail validation.
 */
import { JsonLdScript } from './_shared';

export interface BreadcrumbItem {
  name: string;
  /** Canonical absolute URL. Omit on the last item per Google's docs
   *  (the URL is optional there since clicking reloads the same page);
   *  both forms validate. */
  url?: string;
}

export interface BreadcrumbListSchemaJsonLdProps {
  items: BreadcrumbItem[];
}

export function BreadcrumbListSchemaJsonLd({ items }: BreadcrumbListSchemaJsonLdProps) {
  if (!items || items.length === 0) return null;
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.name,
      item: item.url,
    })),
  };
  return <JsonLdScript schema={schema} id="schema-breadcrumb" />;
}
